// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loginWrapper {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
@media (max-width: 768px) {
  .loginWrapper {
    max-width: 450px;
    margin-right: 0;
  }
}
.loginWrapper .loginContainer {
  padding: 24px;
  width: 100%;
  border: 1px solid #DCDCDC;
  background-color: #ffffff;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0 auto;
  justify-content: center;
  padding-left: 20px;
  padding-right: 20px;
}
@media (max-width: 768px) {
  .loginWrapper .loginContainer {
    padding-left: 24px;
    padding-right: 24px;
  }
}
.loginWrapper .loginContainer .loginHeader .loginTitle {
  font-size: 24px;
  font-weight: 600;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
  color: #000000;
  color: var(--theme-default-text-color, #000000);
}
.loginWrapper .loginContainer .loginHeader .loginSubtitle {
  font-size: 14px;
  font-weight: 400;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
  color: #000000;
}
.loginWrapper .loginContainer .loginContent .loginForm {
  display: flex;
  flex-direction: column;
}
.loginWrapper .loginContainer .loginContent .loginForm label {
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
  color: #000000;
  font-size: 16px;
  display: inline-block;
  margin-bottom: 8px;
}
.loginWrapper .loginContainer .loginContent .loginForm label span {
  color: #EB0000;
}
.loginWrapper .loginContainer .loginContent .loginForm .formField {
  width: 100%;
  padding-bottom: 16px;
}
.loginWrapper .loginContainer .loginContent .loginForm .formField.nameField {
  padding-top: 0;
}
.loginWrapper .loginContainer .loginContent .loginForm .formField.phoneField {
  padding: 0;
  position: relative;
  z-index: 100;
}
.loginWrapper .loginContainer .loginContent .loginForm .formField.phoneField .react-tel-input .form-control {
  color: #000000 !important;
  background: #F7F7F7 !important;
  border: 1px solid #E8E8E8 !important;
  border-radius: 10px !important;
  height: 60px !important;
  width: 100% !important;
  font-weight: 500 !important;
  font-size: 18px !important;
}
.loginWrapper .loginContainer .loginContent .loginForm .formField.phoneField .react-tel-input .contactUsInput {
  border-radius: 20px !important;
  border: none !important;
  padding-left: 60px !important;
}
.loginWrapper .loginContainer .loginContent .loginForm .formField.phoneField .react-tel-input .flag-dropdown {
  background-color: #F7F7F7 !important;
  border: 1px solid #E8E8E8 !important;
  border-radius: 10px 0 0 10px !important;
}
.loginWrapper .loginContainer .loginContent .loginForm .formField.phoneField .react-tel-input .country-list {
  z-index: 1000 !important;
}
@media (max-width: 768px) {
  .loginWrapper .loginContainer .loginContent .loginForm .formField.phoneField .react-tel-input .country-list {
    width: 360px !important;
  }
}
@media (max-width: 575px) {
  .loginWrapper .loginContainer .loginContent .loginForm .formField.phoneField .react-tel-input .country-list {
    width: 300px !important;
  }
}
.loginWrapper .loginContainer .loginContent .loginForm .formField.emailField {
  padding-top: 24px;
  position: relative;
  z-index: 1;
}
.loginWrapper .loginContainer .loginContent .loginForm .formField.emailField .inputWrapper {
  margin-top: 4px;
}
.loginWrapper .loginContainer .loginContent .loginForm .formField.emailField .inputWrapper input {
  padding: 12px 24px;
  height: 60px;
  font-weight: 500;
  font-size: 18px;
  width: 100%;
  border-radius: 10px;
  background-color: #F7F7F7;
}
.loginWrapper .loginContainer .loginContent .loginForm .formField.emailField .inputWrapper input::placeholder {
  font-weight: 400;
  color: #616161;
}
.loginWrapper .loginContainer .loginContent .loginForm .formField.otpField {
  padding-top: 24px;
  position: relative;
  padding-bottom: 0;
}
.loginWrapper .loginContainer .loginContent .loginForm .formField .fieldInput {
  width: -webkit-fill-available;
  -webkit-appearance: none;
          appearance: none;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
  border-radius: 10px;
  border: 1px solid #E8E8E8;
  outline: none;
  padding: 12px 24px;
  background-color: #F7F7F7;
  color: #1E1E1E;
  font-size: 18px;
  font-weight: 500;
  height: 60px;
}
.loginWrapper .loginContainer .loginContent .loginForm .formField .fieldInput::placeholder {
  font-weight: 400;
  color: #000000;
}
.loginWrapper .loginContainer .loginContent .loginForm .formField .fieldInput:focus {
  border-color: #030213;
  box-shadow: 0 0 0 2px rgba(59, 62, 99, 0.102);
}
.loginWrapper .loginContainer .loginContent .loginForm .formField .fieldInput:disabled {
  background-color: #F7F7F7;
  cursor: not-allowed;
}
.loginWrapper .loginContainer .loginContent .loginForm .formField .fieldInput.otpInput {
  color: #000000;
}
.loginWrapper .loginContainer .loginContent .loginForm .formField .fieldInput.otpInput::placeholder {
  color: #000000;
}
.loginWrapper .loginContainer .loginContent .loginForm .formField .fieldError {
  color: #EB0000;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
  font-size: 12px;
  margin-top: 8px;
  margin-bottom: 0;
}
.loginWrapper .loginContainer .loginContent .loginForm .formField .phoneInputContainer {
  position: relative;
  z-index: 0;
}
.loginWrapper .loginContainer .loginContent .loginForm .formField .phoneInputContainer .editNumberButton {
  z-index: 10;
  font-weight: 500;
  font-size: 14px;
  text-decoration: underline;
  padding: 12px;
  position: absolute;
  top: 8px;
  right: 16px;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
  cursor: pointer;
  background: none;
  border: none;
  color: #030213;
}
.loginWrapper .loginContainer .loginContent .loginForm .formField .successMessage {
  display: flex;
  margin-top: 8px;
  gap: 6px;
  font-size: 12px;
  color: #00A664;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
  font-weight: 500;
  align-items: center;
}
.loginWrapper .loginContainer .loginContent .loginForm .formField .errorMessage {
  display: flex;
  align-items: center;
  margin-top: 8px;
  gap: 6px;
  font-size: 12px;
  color: #EB0000;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
  font-weight: 500;
}
.loginWrapper .loginContainer .loginContent .loginForm .formField .requiredStar {
  color: #E11F60;
  position: absolute;
  top: 40px;
  left: 115px;
}
.loginWrapper .loginContainer .loginContent .loginForm .formField .resendOtpContainer {
  padding: 12px;
  position: absolute;
  top: 30px;
  right: 16px;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
}
.loginWrapper .loginContainer .loginContent .loginForm .formField .resendOtpContainer .resendOtpButton {
  font-weight: 500;
  font-size: 14px;
  background: none;
  border: none;
  cursor: pointer;
}
.loginWrapper .loginContainer .loginContent .loginForm .formField .resendOtpContainer .resendOtpButton.disabled {
  color: #616161;
  cursor: not-allowed;
}
.loginWrapper .loginContainer .loginContent .loginForm .formField .resendOtpContainer .resendOtpButton.enabled {
  text-decoration: underline;
  color: #030213;
}
.loginWrapper .loginContainer .loginContent .loginForm .cardNumberSection {
  margin-bottom: 16px;
}
.loginWrapper .loginContainer .loginContent .loginForm .cardNumberSection .cardNumberLabel {
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
  margin-bottom: 12px;
  color: #000000;
}
.loginWrapper .loginContainer .loginContent .loginForm .termsAndConditions {
  padding: 20px 0;
  font-size: 14px;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
  color: #000000;
}
.loginWrapper .loginContainer .loginContent .loginForm .termsAndConditions .termsLink {
  text-decoration: underline;
  cursor: pointer;
  color: #030213;
  color: var(--theme-default-text-color, #030213);
}
.loginWrapper .loginContainer .loginContent .loginForm .termsAndConditions .termsLink:hover {
  text-decoration: none;
}
.loginWrapper .loginContainer .loginContent .loginForm .submitButton {
  width: 100%;
  font-weight: 600;
  height: 60px;
  font-size: 18px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
}
.loginWrapper .loginContainer .loginFooter {
  text-align: center;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
  font-weight: 600;
  font-size: 18px;
  color: #000000;
}
.loginWrapper .loginContainer .loginFooter .loginToogleLink {
  text-decoration: underline;
  cursor: pointer;
  color: var(--theme-default-text-color);
}
.loginWrapper .loginContainer .loginFooter .loginToogleLink:hover {
  text-decoration: none;
}
.loginWrapper .loginContainer .fingerPrintWrapper {
  padding-top: 16px;
  border-top: 1px solid #DCDCDC;
  margin-top: 16px;
}
.loginWrapper .loginContainer .fingerPrintWrapper .fingerPrintButton {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 600;
}
.loginWrapper .loginContainer .fingerPrintWrapper .fingerPrintDescription {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  margin-top: 8px;
}

.loginPageWrapper {
  width: 100%;
  min-height: calc(100vh - 140px);
  display: flex;
  border-top: 1px solid #F7F7F7;
  /* 1. LEFT SIDE: Banner Image */
  /* 2. RIGHT SIDE: Form Section */
}
@media (max-width: 768px) {
  .loginPageWrapper {
    min-height: calc(100vh - 120px);
  }
}
.loginPageWrapper .loginBannerSection {
  display: flex;
  width: 60%;
  background-image: var(--loginBannerSectionBgImage);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  flex-direction: column;
  justify-content: center;
  position: relative;
  /* Desktop: Visible and takes 50% width */
}
.loginPageWrapper .loginBannerSection .bannerOverlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.2) 100%);
  z-index: 1;
}
.loginPageWrapper .loginBannerSection .bannerOverlayTitle {
  position: absolute;
  top: 100px;
  left: 100px;
  z-index: 2;
  color: #ffffff;
  font-size: 28px;
  font-weight: 600;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
}
.loginPageWrapper .loginBannerSection .bannerOverlaySubtitle {
  position: absolute;
  top: 140px;
  left: 100px;
  width: 420px;
  z-index: 2;
  color: #ffffff;
  font-size: 16px;
  font-weight: 400;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
  opacity: 0.9;
}
@media (max-width: 768px) {
  .loginPageWrapper .loginBannerSection {
    display: none;
  }
}
.loginPageWrapper .loginBannerSection .bannerContent {
  position: relative;
  z-index: 2;
  color: #ffffff;
  max-width: 500px;
  padding: 40px;
}
.loginPageWrapper .loginBannerSection .bannerContent .bannerTitle {
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 16px;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
  line-height: 1.2;
}
.loginPageWrapper .loginBannerSection .bannerContent .bannerSubtitle {
  font-size: 18px;
  font-weight: 400;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
  line-height: 1.5;
  opacity: 0.9;
}
.loginPageWrapper .loginFormSection {
  width: 40%;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 100px 28px;
}
@media (max-width: 768px) {
  .loginPageWrapper .loginFormSection {
    width: 100%;
    padding: 20px;
  }
}
.loginPageWrapper .loginFormSection .loginWrapper {
  width: 100%;
  max-width: 380px;
  height: auto;
  margin: 0;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer {
  padding: 0;
  border: none;
}
@media (max-width: 768px) {
  .loginPageWrapper .loginFormSection .loginWrapper .loginContainer {
    border: none;
    box-shadow: none;
    padding: 0;
  }
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .loginHeader .loginTitle {
  font-size: 24px;
  margin-bottom: 0;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .loginHeader .loginSubtitle {
  font-size: 14px;
  color: #6b7280;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer label {
  font-size: 14px;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
  color: #616161;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer label span {
  color: #EB0000;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .formField .inputWrapper {
  margin-top: 4px;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .formField .inputWrapper input {
  padding: 10px;
  font-size: 14px;
  height: 40px;
  border-radius: 4px;
  background-color: transparent !important;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .formField .inputWrapper input::placeholder {
  color: #616161;
  font-weight: 400;
  font-weight: 14px;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .formField.nameField .inputWrapper {
  margin-top: 4px;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .formField.nameField .inputWrapper input {
  padding: 10px;
  height: 40px;
  font-size: 14px;
  border-radius: 4px;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .formField.phoneField {
  padding: 0;
  position: relative;
  z-index: 100;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .formField.phoneField .react-tel-input .form-control {
  color: #000000 !important;
  background: transparent !important;
  border: 1px solid #E8E8E8 !important;
  border-radius: 4px !important;
  height: 40px !important;
  width: 100% !important;
  font-size: 14px !important;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .formField.phoneField .react-tel-input .flag-dropdown {
  background: transparent !important;
  border: 1px solid #E8E8E8 !important;
  border-radius: 4px 0 0 4px !important;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .formField.phoneField .react-tel-input .country-list {
  z-index: 1000 !important;
  width: 380px;
}
@media (max-width: 1100px) {
  .loginPageWrapper .loginFormSection .loginWrapper .loginContainer .formField.phoneField .react-tel-input .country-list {
    width: 300px !important;
  }
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .formField.phoneField .phoneInputContainer .editNumberButton {
  top: 0px;
  right: 0px;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .formField.phoneField .phoneInputContainer .editNumberButton svg {
  width: 14px;
  height: 14px;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .formField.emailField {
  padding-top: 16px;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .formField.emailField .inputWrapper {
  margin-top: 4px;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .formField.emailField .inputWrapper input {
  padding: 10px;
  height: 40px;
  font-size: 14px;
  border-radius: 4px;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .formField.otpField {
  padding-top: 16px;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .formField.otpField .OTPInputWrapper {
  margin-top: 4px;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .formField.otpField .OTPInputWrapper .otpInput {
  height: 40px;
  font-size: 14px;
  padding: 0 16px;
  border-radius: 4px;
  background-color: transparent;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .formField.otpField .OTPInputWrapper .redStar {
  top: 20px;
  left: 85px;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .formField.otpField .OTPInputWrapper .resendText {
  padding: 0;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .formField.otpField .OTPInputWrapper .resendText .resendText {
  font-size: 12px;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .formField .successLoginMessage, .loginPageWrapper .loginFormSection .loginWrapper .loginContainer .formField .errorLoginMessage {
  font-size: 12px;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .formField .successLoginMessage svg, .loginPageWrapper .loginFormSection .loginWrapper .loginContainer .formField .errorLoginMessage svg {
  width: 14px;
  height: 14px;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .termsAndConditions {
  padding: 16px 0;
  font-size: 13px;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .submitButton {
  height: 40px;
  font-size: 16px;
  border-radius: 4px;
}
.loginPageWrapper .loginFormSection .loginWrapper .loginContainer .loginFooter {
  font-size: 16px;
}

.nameModalContent {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.nameModalContent input {
  width: 100%;
  padding: 12px 16px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Pages/Login/Login.scss","webpack://./src/Styles/_mixins.scss","webpack://./src/Styles/_colors.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAAF;ACGE;EDXF;IAWI,gBAAA;IACA,eAAA;EACF;AACF;AACE;EACE,aAAA;EACA,WAAA;EACA,yBAAA;EACA,yBEhBU;EFiBV,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;AACJ;ACjBE;EDIA;IAeI,kBAAA;IACA,mBAAA;EAEJ;AACF;AACM;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EAAA,qDAAA;EACA,cAAA;EAAA,+CAAA;AACR;AAGM;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EAAA,qDAAA;EACA,cE3CM;AF0Cd;AAMM;EACE,aAAA;EACA,sBAAA;AAJR;AAOQ;EACE,gCAAA;EAAA,qDAAA;EACA,cEvDI;EFwDJ,eAAA;EACA,qBAAA;EACA,kBAAA;AALV;AAOU;EACE,cEvCA;AFkCZ;AASQ;EACE,WAAA;EACA,oBAAA;AAPV;AAaU;EACE,cAAA;AAXZ;AAkBU;EACE,UAAA;EACA,kBAAA;EACA,YAAA;AAhBZ;AAoBc;EAEE,yBAAA;EACA,8BAAA;EACA,oCAAA;EACA,8BAAA;EACA,uBAAA;EACA,sBAAA;EACA,2BAAA;EACA,0BAAA;AAlBhB;AAqBc;EACE,8BAAA;EACA,uBAAA;EACA,6BAAA;AAnBhB;AAsBc;EACE,oCAAA;EACA,oCAAA;EACA,uCAAA;AApBhB;AAuBc;EACE,wBAAA;AArBhB;ACrFE;EDyGY;IAKI,uBAAA;EArBhB;AACF;AChGE;ED+GY;IASI,uBAAA;EApBhB;AACF;AAyBU;EACE,iBAAA;EACA,kBAAA;EACA,UAAA;AAvBZ;AAwBY;EACE,eAAA;AAtBd;AAuBc;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,yBE5HE;AFuGlB;AAwBc;EACE,gBAAA;EACA,cEvIE;AFiHlB;AA2BU;EACE,iBAAA;EACA,kBAAA;EACA,iBAAA;AAzBZ;AA4BU;EACE,6BAAA;EACA,wBAAA;UAAA,gBAAA;EACA,gCAAA;EAAA,qDAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBEpJM;EFqJN,cEzIE;EF0IF,eAAA;EACA,gBAAA;EACA,YAAA;AA1BZ;AA4BY;EACE,gBAAA;EACA,cE5KA;AFkJd;AA6BY;EACE,qBEtIE;EFuIF,6CAAA;AA3Bd;AA8BY;EACE,yBErKI;EFsKJ,mBAAA;AA5Bd;AA+BY;EACE,cE1LA;AF6Jd;AA+Bc;EACE,cE7LF;AFgKd;AAkCU;EAEE,cE9KA;EF+KA,gCAAA;EAAA,qDAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AAjCZ;AAoCU;EACE,kBAAA;EACA,UAAA;AAlCZ;AAoCY;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,gCAAA;EAAA,qDAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,cElLE;AFgJhB;AAsCU;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;EACA,cEjNE;EFkNF,gCAAA;EAAA,qDAAA;EACA,gBAAA;EACA,mBAAA;AApCZ;AAuCU;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;EACA,cE3NA;EF4NA,gCAAA;EAAA,qDAAA;EACA,gBAAA;AArCZ;AAwCU;EACE,cE7NE;EF8NF,kBAAA;EACA,SAAA;EACA,WAAA;AAtCZ;AAyCU;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gCAAA;EAAA,qDAAA;AAvCZ;AAyCY;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAvCd;AAyCc;EACE,cElQE;EFmQF,mBAAA;AAvChB;AA0Cc;EACE,0BAAA;EACA,cExOA;AFgMhB;AA8CQ;EACE,mBAAA;AA5CV;AA8CU;EACE,gCAAA;EAAA,qDAAA;EACA,mBAAA;EACA,cE9RE;AFkPd;AAgDQ;EACE,eAAA;EACA,eAAA;EACA,gCAAA;EAAA,qDAAA;EACA,cEtSI;AFwPd;AAgDU;EACE,0BAAA;EACA,eAAA;EACA,cAAA;EAAA,+CAAA;AA9CZ;AAgDY;EACE,qBAAA;AA9Cd;AAmDQ;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AAjDV;AAsDI;EACE,kBAAA;EACA,gCAAA;EAAA,qDAAA;EACA,gBAAA;EACA,eAAA;EACA,cEpUQ;AFgRd;AAsDM;EACE,0BAAA;EACA,eAAA;EACA,sCAAA;AApDR;AAsDQ;EACE,qBAAA;AApDV;AAyDI;EACE,iBAAA;EACA,6BAAA;EACA,gBAAA;AAvDN;AAyDM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;AAvDR;AA0DM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAxDR;;AA+DA;EACE,WAAA;EACA,+BAAA;EACA,aAAA;EACA,6BAAA;EAMA,+BAAA;EA4EA,gCAAA;AA5IF;AC/SE;EDqWF;IAOI,+BAAA;EAzDF;AACF;AA4DE;EACE,aAAA;EACA,UAAA;EACA,kDAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EAoCA,yCAAA;AA7FJ;AA2DI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,mFAAA;EACA,UAAA;AAzDN;AA4DI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,cElZQ;EFmZR,eAAA;EACA,gBAAA;EACA,gCAAA;EAAA,qDAAA;AA1DN;AA6DI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,cE9ZQ;EF+ZR,eAAA;EACA,gBAAA;EACA,gCAAA;EAAA,qDAAA;EACA,YAAA;AA3DN;AC/VE;EDgXA;IA+CI,aAAA;EA5DJ;AACF;AA8DI;EACE,kBAAA;EACA,UAAA;EACA,cE7aQ;EF8aR,gBAAA;EACA,aAAA;AA5DN;AA8DM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gCAAA;EAAA,qDAAA;EACA,gBAAA;AA5DR;AA+DM;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EAAA,qDAAA;EACA,gBAAA;EACA,YAAA;AA7DR;AAmEE;EACE,UAAA;EACA,yBEtcU;EFucV,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;AAjEJ;ACjYE;ED4bA;IASI,WAAA;IACA,aAAA;EAhEJ;AACF;AAkEI;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;AAhEN;AAkEM;EACE,UAAA;EACA,YAAA;AAhER;ACjZE;ED+cI;IAKI,YAAA;IACA,gBAAA;IACA,UAAA;EA/DR;AACF;AAkEU;EACE,eAAA;EACA,gBAAA;AAhEZ;AAmEU;EACE,eAAA;EACA,cEraK;AFoWjB;AAqEQ;EACE,eAAA;EACA,gCAAA;EAAA,qDAAA;EACA,cEreQ;AFkalB;AAqEU;EACE,cE5dA;AFyZZ;AAwEU;EACE,eAAA;AAtEZ;AAuEY;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,wCAAA;AArEd;AAwEY;EACE,cExfI;EFyfJ,gBAAA;EACA,iBAAA;AAtEd;AA2EY;EACE,eAAA;AAzEd;AA0Ec;EACE,aAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AAxEhB;AA6EU;EACE,UAAA;EACA,kBAAA;EACA,YAAA;AA3EZ;AA+Ec;EACE,yBAAA;EACA,kCAAA;EACA,oCAAA;EACA,6BAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;AA7EhB;AAgFc;EACE,kCAAA;EACA,oCAAA;EACA,qCAAA;AA9EhB;AAiFc;EACE,wBAAA;EACA,YAAA;AA/EhB;AC3cE;EDwhBY;IAKI,uBAAA;EA9EhB;AACF;AAmFc;EACE,QAAA;EACA,UAAA;AAjFhB;AAmFgB;EACE,WAAA;EACA,YAAA;AAjFlB;AAuFU;EACE,iBAAA;AArFZ;AAuFY;EACE,eAAA;AArFd;AAsFc;EACE,aAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AApFhB;AAyFU;EACE,iBAAA;AAvFZ;AAyFY;EACE,eAAA;AAvFd;AAwFc;EACE,YAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;AAtFhB;AAwFc;EACE,SAAA;EACA,UAAA;AAtFhB;AAyFc;EACE,UAAA;AAvFhB;AAyFgB;EACE,eAAA;AAvFlB;AA6FU;EACE,eAAA;AA3FZ;AA6FY;EACE,WAAA;EACA,YAAA;AA3Fd;AAkGQ;EACE,eAAA;EACA,eAAA;AAhGV;AAmGQ;EACE,YAAA;EACA,eAAA;EACA,kBAAA;AAjGV;AAoGQ;EACE,eAAA;AAlGV;;AAyGA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAtGF;AAwGE;EACE,WAAA;EACA,kBAAA;AAtGJ","sourcesContent":["@import \"src/Styles/theme.scss\";\n.loginWrapper {\n  width: 100%;\n  max-width: 100%;\n  margin: 0 auto;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n\n  @include respond-md {\n    max-width: 450px;\n    margin-right: 0;\n  }\n\n  .loginContainer {\n    padding: 24px;\n    width: 100%;\n    border: 1px solid $border-color-light-grey;\n    background-color: $color-white;\n    border-radius: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin: 0 auto;\n    justify-content: center;\n    padding-left: 20px;\n    padding-right: 20px;\n\n    @include respond-md {\n      padding-left: 24px;\n      padding-right: 24px;\n    }\n\n    .loginHeader {\n      .loginTitle {\n        font-size: 24px;\n        font-weight: 600;\n        font-family: var(--primary-font, 'Inter', sans-serif);\n        color: var(--theme-default-text-color, #000000);\n        // margin-bottom: 8px;\n      }\n\n      .loginSubtitle {\n        font-size: 14px;\n        font-weight: 400;\n        font-family: var(--primary-font, 'Inter', sans-serif);\n        color: $color-black;\n      }\n    }\n\n    .loginContent {\n      .loginForm {\n        display: flex;\n        flex-direction: column;\n        // gap: 16px;\n\n        label {\n          font-family: var(--primary-font, 'Inter', sans-serif);\n          color: $color-black;\n          font-size: 16px;\n          display: inline-block;\n          margin-bottom: 8px;\n\n          span {\n            color: $color-red;\n          }\n        }\n\n        .formField {\n          width: 100%;\n          padding-bottom: 16px;\n\n          @include respond-md {\n            // padding-bottom: 24px;\n          }\n\n          &.nameField {\n            padding-top: 0;\n\n            @include respond-md {\n              // padding-top: 24px;\n            }\n          }\n\n          &.phoneField {\n            padding: 0;\n            position: relative;\n            z-index: 100;\n\n            // Mobile Number Input Style \n            .react-tel-input {\n              .form-control {\n                font-size: 18px !important;\n                color: $color-black !important;\n                background: $bg-light-grey-2 !important;\n                border: 1px solid $bg-light-grey-1 !important;\n                border-radius: 10px !important;\n                height: 60px !important;\n                width: 100% !important;\n                font-weight: 500 !important;\n                font-size: 18px !important;\n              }\n\n              .contactUsInput {\n                border-radius: 20px !important;\n                border: none !important;\n                padding-left: 60px !important;\n              }\n\n              .flag-dropdown {\n                background-color: $bg-light-grey-2 !important;\n                border: 1px solid $bg-light-grey-1 !important;\n                border-radius: 10px 0 0 10px !important;\n              }\n\n              .country-list {\n                z-index: 1000 !important;\n                // width: 450px !important;\n\n                @include respond-md {\n                  width: 360px !important;\n                }\n\n                @include respond-sm {\n                  width: 300px !important;\n                }\n              }\n            }\n          }\n\n          &.emailField {\n            padding-top: 24px;\n            position: relative;\n            z-index: 1;\n            .inputWrapper {\n              margin-top: 4px;\n              input {\n                padding: 12px 24px;\n                height: 60px;\n                font-weight: 500;\n                font-size: 18px;\n                width: 100%;\n                border-radius: 10px;\n                background-color: $bg-light-grey-2;\n              }\n\n              input::placeholder {\n                font-weight: 400;\n                color: $color-text-grey;\n              }\n            }\n          }\n\n          &.otpField {\n            padding-top: 24px;\n            position: relative;\n            padding-bottom: 0;\n          }\n\n          .fieldInput {\n            width: -webkit-fill-available;\n            appearance: none;\n            font-family: var(--primary-font, 'Inter', sans-serif);\n            border-radius: 10px;\n            border: 1px solid $bg-light-grey-1;\n            outline: none;\n            padding: 12px 24px;\n            background-color: $bg-light-grey-2;\n            color: $stroke-dark;\n            font-size: 18px;\n            font-weight: 500;\n            height: 60px;\n\n            &::placeholder {\n              font-weight: 400;\n              color: $color-black;\n            }\n\n            &:focus {\n              border-color: $color-primary;\n              box-shadow: 0 0 0 2px rgba(59, 62, 99, 0.102);\n            }\n\n            &:disabled {\n              background-color: $bg-light-grey-2;\n              cursor: not-allowed;\n            }\n\n            &.otpInput {\n              color: $color-black;\n\n              &::placeholder {\n                color: $color-black;\n              }\n            }\n          }\n\n          .fieldError {\n            // padding: 8px 16px;\n            color: $color-red;\n            font-family: var(--primary-font, 'Inter', sans-serif);\n            font-size: 12px;\n            margin-top: 8px;\n            margin-bottom: 0;\n          }\n\n          .phoneInputContainer {\n            position: relative;\n            z-index: 0;\n\n            .editNumberButton {\n              z-index: 10;\n              font-weight: 500;\n              font-size: 14px;\n              text-decoration: underline;\n              padding: 12px;\n              position: absolute;\n              top: 8px;\n              right: 16px;\n              font-family: var(--primary-font, 'Inter', sans-serif);\n              cursor: pointer;\n              background: none;\n              border: none;\n              color: $color-primary;\n            }\n          }\n\n          .successMessage {\n            display: flex;\n            margin-top: 8px;\n            gap: 6px;\n            font-size: 12px;\n            color: $color-green;\n            font-family: var(--primary-font, 'Inter', sans-serif);\n            font-weight: 500;\n            align-items: center;\n          }\n\n          .errorMessage {\n            display: flex;\n            align-items: center;\n            margin-top: 8px;\n            gap: 6px;\n            font-size: 12px;\n            color: $color-red;\n            font-family: var(--primary-font, 'Inter', sans-serif);\n            font-weight: 500;\n          }\n\n          .requiredStar {\n            color: $stroke-pink;\n            position: absolute;\n            top: 40px;\n            left: 115px;\n          }\n\n          .resendOtpContainer {\n            padding: 12px;\n            position: absolute;\n            top: 30px;\n            right: 16px;\n            font-family: var(--primary-font, 'Inter', sans-serif);\n\n            .resendOtpButton {\n              font-weight: 500;\n              font-size: 14px;\n              background: none;\n              border: none;\n              cursor: pointer;\n\n              &.disabled {\n                color: $color-text-grey;\n                cursor: not-allowed;\n              }\n\n              &.enabled {\n                text-decoration: underline;\n                color: $color-primary;\n              }\n            }\n          }\n        }\n\n        .cardNumberSection {\n          margin-bottom: 16px;\n\n          .cardNumberLabel {\n            font-family: var(--primary-font, 'Inter', sans-serif);\n            margin-bottom: 12px;\n            color: $color-black;\n          }\n        }\n\n        .termsAndConditions {\n          padding: 20px 0;\n          font-size: 14px;\n          font-family: var(--primary-font, 'Inter', sans-serif);\n          color: $color-black;\n\n          .termsLink {\n            text-decoration: underline;\n            cursor: pointer;\n            color: var(--theme-default-text-color, #030213);\n\n            &:hover {\n              text-decoration: none;\n            }\n          }\n        }\n\n        .submitButton {\n          width: 100%;\n          font-weight: 600;\n          height: 60px;\n          font-size: 18px;\n          border-radius: 10px;\n          border: none;\n          cursor: pointer;\n        }\n      }\n    }\n\n    .loginFooter {\n      text-align: center;\n      font-family: var(--primary-font, 'Inter', sans-serif);\n      font-weight: 600;\n      font-size: 18px;\n      color: $color-black;\n\n      .loginToogleLink {\n        text-decoration: underline;\n        cursor: pointer;\n        color: var(--theme-default-text-color);\n\n        &:hover {\n          text-decoration: none;\n        }\n      }\n    }\n\n    .fingerPrintWrapper {\n      padding-top: 16px;\n      border-top: 1px solid $border-color-light-grey;\n      margin-top: 16px;\n\n      .fingerPrintButton {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 8px;\n        font-weight: 600;\n      }\n\n      .fingerPrintDescription {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 8px;\n        font-size: 14px;\n        font-weight: 600;\n        margin-top: 8px;\n      }\n    }\n  }\n}\n\n// login and sign up page wrapper\n.loginPageWrapper {\n  width: 100%;\n  min-height: calc(100vh - 140px);\n  display: flex;\n  border-top: 1px solid $bg-light-grey-2;\n\n  @include respond-md {\n    min-height: calc(100vh - 120px);\n  }\n\n  /* 1. LEFT SIDE: Banner Image */\n  .loginBannerSection {\n    display: flex;\n    width: 60%;\n    background-image: var(--loginBannerSectionBgImage);\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    flex-direction: column;\n    justify-content: center;\n    position: relative;\n\n    .bannerOverlay {\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.2) 100%);\n      z-index: 1;\n    }\n\n    .bannerOverlayTitle {\n      position: absolute;\n      top: 100px;\n      left: 100px;\n      z-index: 2;\n      color: $color-white;\n      font-size: 28px;\n      font-weight: 600;\n      font-family: var(--primary-font, 'Inter', sans-serif);\n    }\n\n    .bannerOverlaySubtitle {\n      position: absolute;\n      top: 140px;\n      left: 100px;\n      width: 420px;\n      z-index: 2;\n      color: $color-white;\n      font-size: 16px;\n      font-weight: 400;\n      font-family: var(--primary-font, 'Inter', sans-serif);\n      opacity: 0.9;\n    }\n    \n    /* Desktop: Visible and takes 50% width */\n    @include respond-md {\n      display: none; \n    }\n\n    .bannerContent {\n      position: relative;\n      z-index: 2;\n      color: $color-white;\n      max-width: 500px;\n      padding: 40px;\n\n      .bannerTitle {\n        font-size: 36px;\n        font-weight: 700;\n        margin-bottom: 16px;\n        font-family: var(--primary-font, 'Inter', sans-serif);\n        line-height: 1.2;\n      }\n\n      .bannerSubtitle {\n        font-size: 18px;\n        font-weight: 400;\n        font-family: var(--primary-font, 'Inter', sans-serif);\n        line-height: 1.5;\n        opacity: 0.9;\n      }\n    }\n  }\n\n  /* 2. RIGHT SIDE: Form Section */\n  .loginFormSection {\n    width: 40%;\n    background-color: $color-white;\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    padding: 100px 28px;\n    \n    @include respond-md {\n      width: 100%;\n      padding: 20px;\n    }\n\n    .loginWrapper {\n      width: 100%;\n      max-width: 380px; \n      height: auto;     \n      margin: 0;\n      \n      .loginContainer {\n        padding: 0;\n        border: none;\n\n        @include respond-md {\n          border: none;\n          box-shadow: none;\n          padding: 0;\n        }\n\n        .loginHeader {\n          .loginTitle {\n            font-size: 24px;\n            margin-bottom: 0;\n          }\n\n          .loginSubtitle {\n            font-size: 14px;\n            color: $color-gray-500;\n          }\n        }\n\n        label {\n          font-size: 14px;\n          font-family: var(--primary-font, 'Inter', sans-serif);\n          color: $color-text-grey;\n\n          span {\n            color: $color-red;\n          }\n        }\n        \n        .formField {\n          .inputWrapper {\n            margin-top: 4px;\n            input {\n              padding: 10px;\n              font-size: 14px;\n              height: 40px;\n              border-radius: 4px;\n              background-color: transparent !important;\n            }\n\n            input::placeholder {\n              color: $color-text-grey;\n              font-weight: 400;\n              font-weight: 14px;\n            }\n          }\n\n          &.nameField {\n            .inputWrapper {\n              margin-top: 4px;\n              input {\n                padding: 10px;\n                height: 40px;\n                font-size: 14px;\n                border-radius: 4px;\n              }\n            }\n          }\n\n          &.phoneField {\n            padding: 0;\n            position: relative;\n            z-index: 100;\n\n            // Mobile Number Input Style \n            .react-tel-input {\n              .form-control {\n                color: $color-black !important;\n                background: transparent !important;\n                border: 1px solid $bg-light-grey-1 !important;\n                border-radius: 4px !important;\n                height: 40px !important;\n                width: 100% !important;\n                font-size: 14px !important;\n              }\n\n              .flag-dropdown {\n                background: transparent !important;\n                border: 1px solid $bg-light-grey-1 !important;\n                border-radius: 4px 0 0 4px !important;\n              }\n\n              .country-list {\n                z-index: 1000 !important;\n                width: 380px;\n\n                @include respond-xlg {\n                  width: 300px !important;\n                }\n              }\n            }\n\n            .phoneInputContainer {\n              .editNumberButton {\n                top: 0px;\n                right: 0px;\n\n                svg {\n                  width: 14px;\n                  height: 14px;\n                }\n              }\n            }\n          }\n\n          &.emailField {\n            padding-top: 16px;\n\n            .inputWrapper {\n              margin-top: 4px;\n              input {\n                padding: 10px;\n                height: 40px;\n                font-size: 14px;\n                border-radius: 4px;\n              }\n            }\n          }\n\n          &.otpField {\n            padding-top: 16px;\n\n            .OTPInputWrapper {\n              margin-top: 4px;\n              .otpInput {\n                height: 40px;\n                font-size: 14px;\n                padding:0 16px;\n                border-radius: 4px;\n                background-color: transparent;\n              }\n              .redStar {\n                top: 20px;\n                left: 85px;\n              }\n\n              .resendText {\n                padding: 0;\n\n                .resendText {\n                  font-size: 12px;\n                }\n              }\n            }\n          }\n\n          .successLoginMessage, .errorLoginMessage {\n            font-size: 12px;\n\n            svg {\n              width: 14px;\n              height: 14px;\n            }\n          }\n\n        }\n\n\n        .termsAndConditions {\n          padding: 16px 0;\n          font-size: 13px;\n        }\n\n        .submitButton {\n          height: 40px;\n          font-size: 16px;\n          border-radius: 4px;\n        }\n\n        .loginFooter {\n          font-size: 16px;\n        }\n      }\n    }\n  }\n}\n\n.nameModalContent {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  input {\n    width: 100%;\n    padding: 12px 16px;\n  }\n}","@import './breakpoints';\n\n// ====================================\n// 📱 Media Query Mixins\n// ====================================\n@mixin respond-sm {\n  @media (max-width: $breakpoint-sm) {\n    @content;\n  }\n}\n\n@mixin respond-md {\n  @media (max-width: $breakpoint-md) {\n    @content;\n  }\n}\n\n@mixin respond-lg {\n  @media (max-width: $breakpoint-lg) {\n    @content;\n  }\n}\n\n@mixin respond-xlg {\n  @media (max-width: $breakpoint-xlg) {\n    @content;\n  }\n}\n\n@mixin respond-xxlg {\n  @media (max-width: $breakpoint-xxlg) {\n    @content;\n  }\n}\n\n@mixin respond-xxxlg {\n  @media (max-width: $breakpoint-xxxlg) {\n    @content;\n  }\n}\n\n@mixin respond-max {\n  @media (max-width: $breakpoint-max) {\n    @content;\n  }\n}\n","// ====================================\n// 🎨 Color Variables\n// ====================================\n\n$color-white: #ffffff;\n$color-black: #000000;\n\n// Primary Colors\n$color-primary-pink: #EA2466;\n$color-secondary-pink: #F5437E;\n$color-primary-dark-grey: #383838;\n$color-primary-medium-grey: #4a4a4a;\n$color-primary-light-grey: #808080;\n$color-border-primary-grey: #e2e8f0;\n// $color-border-primary-grey: #b4b4b4;\n$color-text-grey: #616161;\n\n// Background Colors\n$bg-pink-10: #FDECF2; // approximated 10% of #EA2466\n$bg-white: #FFFFFF;\n$bg-light-grey-1: #E8E8E8;\n$bg-light-grey-2: #F7F7F7;\n$bg-light-grey-3: #EDEDED;\n\n// Misc Colors\n$color-green: #00A664;\n$color-yellow: #FECE00;\n$color-red: #EB0000;\n$border-color-light-grey: #DCDCDC;\n\n// Stroke Colors\n$stroke-pink: #E11F60;\n$stroke-black: #000000;\n$stroke-dark: #1E1E1E;\n$stroke-grey: #E5E5E5;\n\n// Hover Colors\n$hover-pink: #CB104E;\n$hover-dark-grey: #484848;\n// $hover-light-grey: #EDEDED;\n\n// ====================================\n// ****** Precious Metals Theme *******\n// ====================================\n\n// Base Colors--\n$color-foreground: #252525;\n$color-primary: #030213;\n$color-secondary: #f2f1fc;\n$color-muted: #ececf0;\n$color-muted-foreground: #717182;\n$color-accent: #e9ebef;\n$color-destructive: #d4183d;\n$color-border: rgba(0, 0, 0, 0.1);\n$color-input: transparent;\n$color-input-background: #f3f3f5;\n$color-switch-background: #cbced4;\n$color-ring: #b50000;\n\n// Chart Colors--\n$chart-1: #f18b00;\n$chart-2: #3a9ac3;\n$chart-3: #6d91db;\n$chart-4: #f2ab00;\n$chart-5: #f9a800;\n\n// Gray Scale--\n$color-gray-50: #f9fafb;\n$color-gray-100: #f3f4f6;\n$color-gray-200: #e5e7eb;\n$color-gray-300: #d1d5db;\n$color-gray-400: #9ca3af;\n$color-gray-500: #6b7280;\n$color-gray-600: #4b5563;\n$color-gray-700: #374151;\n$color-gray-800: #1f2937;\n$color-gray-900: #111827;\n$color-gray-950: #030712;\n\n// Gold Colors\n$color-gold-50: #fffbeb;\n$color-gold-100: #fef3c7;\n$color-gold-200: #fde68a;\n$color-gold-300: #fcd34d;\n$color-gold-400: #fbbf24;\n$color-gold-500: #f59e0b;\n$color-gold-600: #d97706;\n$color-gold-700: #b45309;\n$color-gold-800: #92400e;\n$color-gold-900: #78350f;\n\n// Silver Colors\n$color-silver-50: #f8fafc;\n$color-silver-100: #f1f5f9;\n$color-silver-200: #e2e8f0;\n$color-silver-300: #cbd5e1;\n$color-silver-400: #94a3b8;\n$color-silver-500: #64748b;\n$color-silver-600: #475569;\n$color-silver-700: #334155;\n$color-silver-800: #1e293b;\n$color-silver-900: #0f172a;\n\n// Blue Colors\n$color-blue-50: #eff6ff;\n$color-blue-100: #dbeafe;\n$color-blue-200: #bfdbfe;\n$color-blue-300: #93c5fd;\n$color-blue-400: #60a5fa;\n$color-blue-500: #3b82f6;\n$color-blue-600: #2563eb;\n$color-blue-700: #1d4ed8;\n$color-blue-800: #1e40af;\n$color-blue-900: #1e3a8a;\n\n// Green Colors (Additional to system green)\n$color-green-50: #f0fdf4;\n$color-green-100: #dcfce7;\n$color-green-200: #bbf7d0;\n$color-green-300: #86efac;\n$color-green-400: #4ade80;\n$color-green-500: #22c55e;\n$color-green-600: #00A664;\n$color-green-700: #15803d;\n$color-green-800: #166534;\n$color-green-900: #14532d;\n\n// Red Colors (Additional to system red)\n$color-red-50: #fef2f2;\n$color-red-100: #fee2e2;\n$color-red-200: #fecaca;\n$color-red-300: #fca5a5;\n$color-red-400: #f87171;\n$color-red-500: #ef4444;\n$color-red-600: #EB0000;\n$color-red-700: #b91c1c;\n$color-red-800: #991b1b;\n$color-red-900: #7f1d1d;\n\n// Purple Colors\n$color-purple-50: #f5f3ff;\n$color-purple-100: #f3e8ff;\n$color-purple-200: #e9d5ff;\n$color-purple-300: #d8b4fe;\n$color-purple-400: #c084fc;\n$color-purple-500: #a855f7;\n$color-purple-600: #9333ea;\n$color-purple-700: #7c3aed;\n$color-purple-800: #6b21a8;\n$color-purple-900: #581c87;\n\n// Indigo Colors\n$color-indigo-50: #eef2ff;\n$color-indigo-100: #e0e7ff;\n$color-indigo-200: #c7d2fe;\n$color-indigo-300: #a5b4fc;\n$color-indigo-400: #818cf8;\n$color-indigo-500: #6366f1;\n$color-indigo-600: #4f46e5;\n$color-indigo-700: #4338ca;\n$color-indigo-800: #3730a3;\n$color-indigo-900: #312e81;\n\n// yellow Colors\n$color-yellow-50: #fefce8;\n$color-yellow-100: #fef9c3;\n$color-yellow-200: #fef08a;\n$color-yellow-300: #fde047;\n$color-yellow-400: #facc15;\n$color-yellow-500: #eab308;\n$color-yellow-600: #ca8a04;\n$color-yellow-700: #a16207;\n$color-yellow-800: #854d0e;\n$color-yellow-900: #713f12;\n\n// Orange Colors\n$color-orange-50: #fff7ed;\n$color-orange-100: #ffedd5;\n$color-orange-200: #fed7aa; \n$color-orange-300: #fdba74;\n$color-orange-400: #fb923c;\n$color-orange-500: #f97316;\n$color-orange-600: #ea580c;\n$color-orange-700: #c2410c;\n$color-orange-800: #9a3412;\n$color-orange-900: #7c2d12;\n\n// pink Colors\n$color-pink-50: #fdf2f8;\n$color-pink-100: #fce7f3;\n$color-pink-200: #fbcfe8;\n$color-pink-300: #f9a8d4;\n$color-pink-400: #f472b6;\n$color-pink-500: #ec4899;\n$color-pink-600: #db2777;\n$color-pink-700: #be185d;\n$color-pink-800: #9d174d;\n$color-pink-900: #831843;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
